import { render, staticRenderFns } from "./CustomerZip.vue?vue&type=template&id=24cd840f&"
import script from "./CustomerZip.vue?vue&type=script&lang=js&"
export * from "./CustomerZip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports